module.exports = __webpack_public_path__ + "img/1557614089299107841.ed10e3a1.png";